import { render, staticRenderFns } from "./SongPage.vue?vue&type=template&id=9ca6c866&scoped=true&"
import script from "./SongPage.vue?vue&type=script&lang=js&"
export * from "./SongPage.vue?vue&type=script&lang=js&"
import style0 from "./SongPage.vue?vue&type=style&index=0&id=9ca6c866&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca6c866",
  null
  
)

component.options.__file = "SongPage.vue"
export default component.exports